import Route from '@ember/routing/route';

export default class AuthenticatedReimaginedLpnIndexRoute extends Route {}
